/* ── Quantity Input Custom Element ── */
class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.quantity-input__field');
    this.minusBtn = this.querySelector('[name="minus"]');
    this.plusBtn = this.querySelector('[name="plus"]');

    if (this.minusBtn) {
      this.minusBtn.addEventListener('click', this.decrease.bind(this));
    }
    if (this.plusBtn) {
      this.plusBtn.addEventListener('click', this.increase.bind(this));
    }
    if (this.input) {
      this.input.addEventListener('change', this.onInputChange.bind(this));
    }
  }

  get value() {
    return parseInt(this.input.value, 10) || 0;
  }

  get min() {
    return parseInt(this.input.min, 10) || 0;
  }

  get max() {
    return this.input.max ? parseInt(this.input.max, 10) : Infinity;
  }

  decrease() {
    var newVal = Math.max(this.min, this.value - 1);
    this.input.value = newVal;
    this.updateButtons();
    this.dispatchEvent(new CustomEvent('quantity:change', { detail: { value: newVal }, bubbles: true }));
  }

  increase() {
    var newVal = Math.min(this.max, this.value + 1);
    this.input.value = newVal;
    this.updateButtons();
    this.dispatchEvent(new CustomEvent('quantity:change', { detail: { value: newVal }, bubbles: true }));
  }

  onInputChange() {
    var val = this.value;
    if (val < this.min) val = this.min;
    if (val > this.max) val = this.max;
    this.input.value = val;
    this.updateButtons();
    this.dispatchEvent(new CustomEvent('quantity:change', { detail: { value: val }, bubbles: true }));
  }

  updateButtons() {
    if (this.minusBtn) this.minusBtn.disabled = (this.value <= this.min);
    if (this.plusBtn) this.plusBtn.disabled = (this.value >= this.max);
  }
}

customElements.define('quantity-input', QuantityInput);
